// DatosTabXL - Sprint 44 Fase 3 Vista 2.
// Datos basicos del cliente (7 campos). Usa XLInput + XLSelect con PAISES.
// Reemplaza el componente local PaisSelect (deuda: se consolido al XLSelect
// generico con options=PAISES).
import { useEffect } from 'react';
import { ensureKeyframes, injectCSS } from '../../../design/motion';
import XLInput from '../../../components/xl/XLInput';
import XLSelect from '../../../components/xl/XLSelect';
import { PAISES } from '../../clientes/form/utils';

const CSS_ID = 'xl-cli-datos-css';
const CSS = `
.xl-form-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
}
@media (max-width: 720px) { .xl-form-grid { grid-template-columns: 1fr } }
.xl-form-grid__full { grid-column: 1 / -1 }
`;

const PAIS_OPTIONS = [
  { value: '', label: 'Selecciona un pais...' },
  ...PAISES.map((p) => ({ value: p.name, label: p.name })),
];

export default function DatosTabXL({ form, set }) {
  useEffect(() => {
    ensureKeyframes();
    injectCSS(CSS_ID, CSS);
  }, []);

  return (
    <div className="xl-form-grid">
      <div className="xl-form-grid__full">
        <XLInput
          label="Nombre *"
          value={form.nombre || ''}
          onChange={(e) => set('nombre', e.target.value)}
          placeholder="Razon social o nombre"
        />
      </div>
      <XLInput
        label="Email"
        type="email"
        value={form.email || ''}
        onChange={(e) => set('email', e.target.value)}
        placeholder="cliente@email.com"
      />
      <XLInput
        label="Telefono"
        value={form.telefono || ''}
        onChange={(e) => set('telefono', e.target.value)}
        placeholder="+57 300 123 4567"
      />
      <XLSelect
        label="Pais"
        value={form.pais || ''}
        onChange={(e) => set('pais', e.target.value)}
        options={PAIS_OPTIONS}
      />
      <XLInput
        label="Region / Departamento / Estado"
        value={form.region || ''}
        onChange={(e) => set('region', e.target.value)}
        placeholder="Antioquia, California..."
      />
      <XLInput
        label="Ciudad / Municipio"
        value={form.ciudad || ''}
        onChange={(e) => set('ciudad', e.target.value)}
        placeholder="Medellin"
      />
      <div className="xl-form-grid__full">
        <XLInput
          label="Direccion"
          value={form.direccion || ''}
          onChange={(e) => set('direccion', e.target.value)}
          placeholder="Calle / numero / interior..."
        />
      </div>
    </div>
  );
}
